export default "__VITE_ASSET__BB6ubjxc__"